module.exports = __webpack_public_path__ + "static/img/LxxljkscV2.b8d3922a.png";